import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {DateAdapter} from '@angular/material/core';
import {MatTableDataSource} from '@angular/material/table';
import {Frequency} from '../models/frequency';
import {TotenService} from '../services/toten.service';
import {SpinnerService} from '../shared/waiting/spinner.service';
import {ConfirmComponent} from '../shared/dialogs/confirm/confirm.component';
import {AuthService} from '../services/auth.service';
import {FileService} from '../services/file.service';

@Component({
  selector: 'app-toten-report',
  templateUrl: './toten-report.component.html',
  styleUrls: [ './toten-report.component.scss' ]
})
export class TotenReportComponent implements OnInit {

  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'date', 'member', 'delete' ];

  public products: any[] = []
  public selectedProduct: any = {};
  public countUniqueEntries: number = 0;

  constructor (
    public _totenService: TotenService,
    private _spinnerService: SpinnerService,
    private dialog: MatDialog,
    private _fileService: FileService,
    public _authService: AuthService,
    private _adapter: DateAdapter<any>,
  ) {
    this.loadProducts()
    //this.loadFrequency()
  }

  ngOnInit () {
    this._adapter.setLocale('pt');
  }

  applyFilter (filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  loadFrequency (product_id) {
    const waiting = this._spinnerService.show();

    this._totenService.loadFrequency(product_id)
      .subscribe((result) => {
        let array: Frequency[] = []

        this.countUniqueEntries = 0;

        result.forEach((item) => {
          let entity: Frequency = new Frequency()
          entity.id = item.payload.doc.id
          entity.activity_id = item.payload.doc.data().activity_id
          entity.activity_name = item.payload.doc.data().activity_name
          entity.date = item.payload.doc.data().date
          entity.day_id = item.payload.doc.data().day_id
          entity.day_name = item.payload.doc.data().day_name
          entity.event_id = item.payload.doc.data().event_id
          entity.event_name = item.payload.doc.data().event_name
          entity.member_category_id = item.payload.doc.data().member_category_id
          entity.member_category_name = item.payload.doc.data().member_category_name
          entity.member_id = item.payload.doc.data().member_id
          entity.member_name = item.payload.doc.data().member_name
          entity.topic_id = item.payload.doc.data().topic_id
          entity.topic_name = item.payload.doc.data().topic_name
          entity.type = item.payload.doc.data().type

          const exist = array.find((e) => {
            return e.member_name === item.payload.doc.data().member_name
          })
          if (!exist) {
            this.countUniqueEntries++
          }
          array.push(entity)
        })

        this.dataSource = new MatTableDataSource(array);
        waiting.close()
        //console.log('countUniqueEntries: ' + this.countUniqueEntries)
      })
  }

  exportToCsv () {

    let csvFile: any[] = []
    let data: any[] = this.dataSource.data;

    csvFile.push("" + ";" + this.productSelected.name + " - Presenças" + '\r\n')

    let csvHeader: string;

    csvHeader = "" + ";"
    csvHeader += 'Inscrito' + ';'
    csvHeader += 'Data' + ';'
    csvHeader += 'Evento' + '\r\n'

    csvFile.push(csvHeader)

    data.forEach((item) => {

      let dt = this.formatDate(item.date)

      let csvLine: string;
      csvLine = "" + ";"
      csvLine += (item.member_name || '') + ";";
      csvLine += (dt || '-') + ";";
      csvLine += (item.event_name || '') + "\r\n";

      csvFile.push(csvLine)

    })

    var BOM = "\ufeff";
    let csvData = BOM + csvFile;

    var blob = new Blob([ csvData ], {type: "text/csv;charset=utf-8"});

    this._fileService.saveFile(blob, this.productSelected.name + " - Presenças.csv");

  }

  formatDate (dt: any) {
    const date: Date = new Date(dt.seconds * 1000)

    const dd = date.getDate()
    const MM = date.getMonth() + 1
    const yy = date.getFullYear()

    const hh = date.getHours()
    const mm = date.getMinutes()

    return dd + "/" + MM + "/" + yy + " - " + hh + ":" + mm

  }

  loadProducts () {
    this.products.push({'id': 'zc14xOkyPrSHp1NrV5HU', 'name': 'Simpósio dos 40 anos do BJCVS'}) //product_id
    this.products.push({'id': '4s2i5blc1zRNvrBOcL6o', 'name': '52º Congresso da SBCCV • 2026'}) //product_id
    this.products.push({'id': 'UkuE4oCO7RH0UvJEHwys', 'name': '51º Congresso da SBCCV • 2025'}) //product_id
    this.products.push({'id': '2vgQyqXZWjsrYWngGV6A', 'name': '50º Congresso da SBCCV • 2024'}) //product_id
    this.products.push({'id': '5iO9TuQUIITYBvwOJuao', 'name': '49º Congresso da SBCCV • 2023'}) //product_id
    // this.products.push({'id': '67joPLapjeEAAp3GWlEe', 'name': '48º Congresso SBCCV • 2022'})  //event_id
  }

  public productSelected: any = {};

  selectedByProduct (event) {
    console.log(event)
    this.productSelected = this.products.find((e) => {
      return e.id == event
    })
    this.loadFrequency(event)
  }


  delete (element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.member_name + "<br><br>Excluir esta entrada?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._totenService.delete(element.id)
          .then(
            () => {
              //this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete regional error: " + error.message)}
          )

      }
    })
  }

}
